module.exports = __webpack_public_path__ + "static/media/support.fb7deb57.png";